import { useFeatureFlag } from "@/contexts/FeatureFlagContext"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useState } from "react"
import { useNotes } from "../../../api/notesApi"
import { CollapsibleSection } from "../../shared/CollapsibleSection"
import { NotesSection } from "../../shared/notes/NotesSection"

/** Internal notes on one supplier. A note can warn on every new inquiry to it. */
export function SupplierNotesSection({ supplierId }: { supplierId: string }) {
  const { translate } = useTranslation()
  const enabled = useFeatureFlag("MC_NOTES")
  const { data: notes } = useNotes("supplier", supplierId)
  // Closed like the other detail sections while there is nothing to read, open as
  // soon as the supplier has a note: a warning that starts closed is a warning
  // nobody reads. Once shown open it stays open, and the user's own toggle wins.
  const [hadNotes, setHadNotes] = useState(false)
  const [toggled, setToggled] = useState<boolean | null>(null)
  if (!hadNotes && notes && notes.length > 0) setHadNotes(true)
  if (!enabled) return null
  return (
    <CollapsibleSection
      label={translate("MC_NOTES_TITLE")}
      open={toggled ?? hadNotes}
      onOpenChange={setToggled}
    >
      <NotesSection entityType="supplier" entityId={supplierId} embedded />
    </CollapsibleSection>
  )
}
